"use client";
import {
  Switch,
  useComputedColorScheme,
  useMantineColorScheme,
} from "@mantine/core";
import DarkModeRounded from "@mui/icons-material/DarkModeRounded";
import LightModeRounded from "@mui/icons-material/LightModeRounded";

export default function DarkModeToggle({
  size = "sm",
  styles,
}: {
  size?: string;
  styles?: Record<string, React.CSSProperties>;
}) {
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });
  const dark = computedColorScheme === "dark";
  const thumbColor = dark ? "darkblue" : "gold";
  return (
    <Switch
      radius={"lg"}
      aria-label="Dark mode toggle"
      checked={dark}
      onChange={() => setColorScheme(dark ? "light" : "dark")}
      size={size}
      color="dark"
      thumbIcon={
        dark ? (
          <DarkModeRounded
            style={{ width: "0.8rem", height: "0.8rem" }}
            htmlColor="white"
          />
        ) : (
          <LightModeRounded
            style={{ width: "0.8rem", height: "0.8rem" }}
            htmlColor="white"
          />
        )
      }
      styles={{
        ...styles,
        trackLabel: { margin: "0 !important" },
        thumb: { backgroundColor: thumbColor, border: "none" },
      }}
    />
  );
}
